export const getPayload = ({ pickupDates, timeRanges, selectedPickupDate, selectedTimeRange }) => {
  return {
    pickup_date: pickupDates?.length > 1 ? selectedPickupDate : null,
    delivery_time_range_id: timeRanges?.length > 0 && pickupDates?.length > 1 ? selectedTimeRange : null,
  }
}
